/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Paper,
  Typography,
  TextField,
  styled,
  Modal,
  Box,
  Avatar,
} from "@mui/material";
import Color from "../../theme/color";
import { LoadingButton } from "@mui/lab";
import { POST } from "../../config/https";
import APIS from "../../config/api";
import { useNavigate } from "react-router-dom";
import { isEmpty, isValidEmail } from "../../utils/validator";
import ValidationError from "../../components/validation-error-label";
import FullScreenLoader from "../../components/full-screen-loader";
import palette from "../../theme/palette";
import { marginBottomSize } from "../../utils/constant";
import { ContactUsMenu } from "../../assets/data/all-data";
import ContactUsTopTabBar from "../../components/contactUs-app-bar";
import CheckIcon from "@mui/icons-material/Check";
import BottomTab from "../../components/bottom-tab";
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
};

const formDataType = {
  firstName: "",
  lastName: "",
  email: "",
  description: "",
};

const Footer = styled("div")(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: palette.grey[300],
  padding: 15,
  marginTop: "auto",
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const ContactUs: React.FC = () => {
  const [isValidation, setIsValidation] = useState(false);
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState(formDataType);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/");
  };

  let year = new Date().getFullYear();
  const navigate = useNavigate();
  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [
    formData.firstName,
    formData.lastName,
    formData.email,
    formData.description,
    isValidation,
  ]);
  const onChangeText = (key: string, e: any) => {
    let newData = { ...formData };
    switch (key) {
      case "firstName":
        newData.firstName = e.target.value;
        break;
      case "lastName":
        newData.lastName = e.target.value;
        break;
      case "email":
        newData.email = e.target.value;
        break;
      case "description":
        newData.description = e.target.value;
        break;
    }
    setFormData(newData);
  };

  const handleClick = async () => {
    setIsValidation(true);
    if (!validator()) return;
    setLoader(true);
    let param = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      description: formData.description,
    };
    await POST(APIS.CONTACT_US, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          handleOpen();
        } else {
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const validator = () => {
    const errors: Record<string, string> = {};
    if (isEmpty(formData.firstName)) {
      errors.firstName = "Please enter a firstName";
    }
    if (isEmpty(formData.email)) {
      errors.email = "Please enter a email";
    }
    if (!isEmpty(formData.email) && !isValidEmail(formData.email)) {
      errors.email = "Please enter a valid email";
    }
    if (isEmpty(formData.description)) {
      errors.description = "Please enter a description";
    }
    if (isEmpty(formData.lastName)) {
      errors.lastName = "Please enter a lastName";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  return (
    <>
      <Grid item xs={12} md={12}>
        <ContactUsTopTabBar
          backgroundColors={"transparent"}
          textColor={"#fff"}
          boxShadow={"none"}
          iconColor={"#fff"}
          pages={ContactUsMenu}
          event={"events"}
        />
        <Paper elevation={3} style={{ marginBottom: "30px" }}>
          <div
            style={{
              backgroundImage:
                'url("https://eventprix.com/wp-content/uploads/2023/04/Contact-Us-Banner.jpg")',
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
              }}
            ></div>
            <Typography variant="h3" style={{ zIndex: 1, color: "white" }}>
              Contact Us
            </Typography>
          </div>
        </Paper>
      </Grid>
      <div style={{ paddingLeft: 0, paddingRight: 0, width: "100%" }}>
        <Container maxWidth="lg" style={{ marginBottom: marginBottomSize }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper elevation={3} style={{ padding: "20px", height: "100%" }}>
                <Typography variant="h3">Our Headquarters</Typography>
                <Typography variant="h6">1904 Donetto Dr</Typography>
                <Typography>Leander, TX 78641</Typography>
                <Typography>Phone: 737-587-0412</Typography>
                <Typography>Email: contact@eventprix.com</Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper elevation={3} style={{ padding: "20px", height: "100%" }}>
                <Typography variant="h3">Contact Form</Typography>
                <TextField
                  label="First Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => onChangeText("firstName", e)}
                />
                <ValidationError formErrors={formErrors.firstName} />
                <TextField
                  label="Last Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => onChangeText("lastName", e)}
                />
                <ValidationError formErrors={formErrors.lastName} />
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => onChangeText("email", e)}
                />
                <ValidationError formErrors={formErrors.email} />
                <TextField
                  label="Description"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={4}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => onChangeText("description", e)}
                />
                <ValidationError formErrors={formErrors.description} />
                <LoadingButton
                  style={{ backgroundColor: Color.primary, width: "100%" }}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  onClick={handleClick}
                >
                  Send Message
                </LoadingButton>
                <FullScreenLoader open={loader} />
              </Paper>
            </Grid>
          </Grid>
        </Container>
       {/* <Footer>
           <Typography>
            Copyright© {year} EventPrix LLC. All Rights Reserved.
          </Typography> 
          
        </Footer>*/}
        <BottomTab />
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            textAlign={"center"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Avatar
              alt="Rey Sharp"
              sx={{
                width: 56,
                height: 56,
                backgroundColor: palette.success.dark,
              }}
            >
              <CheckIcon sx={{ width: "40px", height: "40px" }} />
            </Avatar>
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            textAlign={"center"}
          >
            Thank you! Your message is sent.
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default ContactUs;
